import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { fourDiagrams } from '@/mocks/jiuchou-architecture';

export default function FourDiagrams() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="投资人四张图"
            title="看懂九畴云铺，只需四张图"
            subtitle="从「是什么」「怎么运行」「靠什么运行」「怎么做大」四个维度，快速建立对项目的完整认知。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {fourDiagrams.map((d, i) => (
            <Reveal key={d.no} delay={i * 80}>
              <div className="h-full p-6 rounded-lg bg-background-100 border border-background-200 flex flex-col">
                <div className="flex items-center justify-between">
                  <div className="w-12 h-12 rounded-lg bg-accent-100 flex items-center justify-center">
                    <i className={`${d.icon} text-accent-700 text-2xl`}></i>
                  </div>
                  <span className="font-heading font-bold text-2xl text-foreground-200">
                    {d.no}
                  </span>
                </div>
                <h3 className="mt-4 font-heading font-bold text-lg text-foreground-950">
                  {d.title}
                </h3>
                <div className="mt-1 text-sm font-medium text-primary-600">{d.question}</div>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{d.answer}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}